"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIAGNOSTIC_ROUTE = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Quiz_1 = __importDefault(require("../Quiz"));
const RootElement_1 = __importDefault(require("../RootElement"));
const PublicQuiz_1 = __importDefault(require("../PublicQuiz"));
exports.DIAGNOSTIC_ROUTE = [
    {
        path: ':testTypeID',
        element: (0, jsx_runtime_1.jsx)(RootElement_1.default, {}),
    },
    {
        path: ':testTypeID/fulllength',
        element: (0, jsx_runtime_1.jsx)(RootElement_1.default, { fulllength: true }),
    },
    {
        path: 'quiz/:quizId',
        element: (0, jsx_runtime_1.jsx)(Quiz_1.default, {}),
    },
    {
        path: 'public-quiz',
        element: (0, jsx_runtime_1.jsx)(PublicQuiz_1.default, {}),
    },
];
